import { Injectable } from '@angular/core';
import { map, firstValueFrom } from 'rxjs';
import { DiagnosticoMatriculaDto } from '../../dtos';
import { environment } from '../../../environments/environment';
import { CaqRequestService } from '../'
import { LocalizacaoService } from '../localizacao/localizacao.service';
import { TipoSimulacao } from '../../enums/simulation-type.enum';

interface ListDiagnosticoMatricula {
  content: DiagnosticoMatriculaDto[];
}

@Injectable({
  providedIn: 'root'
})
export class DiagnosticoMatriculaService {

  private baseApiUrl = `${environment.apiUrl}/diagnostico-de-matricula`;

  constructor(
    private caqRequestService: CaqRequestService,
    private localizacaoService: LocalizacaoService
  ) { }

  buscarListaDeDiagnosticoMatricula(): Promise<DiagnosticoMatriculaDto[]> {
    const localizacao = this.localizacaoService.obterLocalizacaoSelecionada();
    const tipoSimulacao = this.localizacaoService.obterTipoSimulacao();
    
    let endpoint = '';

    if (!localizacao || (!localizacao.estadoSelecionado && !localizacao.cidadeSelecionada)) {
      endpoint = `${this.baseApiUrl}/nacional`;
    } else if (localizacao.cidadeSelecionada) {
      const codMun = localizacao.cidadeSelecionada.value;
      if (tipoSimulacao === TipoSimulacao.planejamento) {
        endpoint = `${this.baseApiUrl}/plano/municipio/${codMun}`;
      } else if (tipoSimulacao === TipoSimulacao.planejamentoPorEsferaAdmMunicipal) {
        endpoint = `${this.baseApiUrl}/rede/municipio/${codMun}`;
      } else {
        endpoint = `${this.baseApiUrl}/plano/municipio/${codMun}`;
      }
    } else {
      endpoint = `${this.baseApiUrl}/nacional`;
    }

    return firstValueFrom(
      this.caqRequestService
      .get<ListDiagnosticoMatricula>(endpoint)
      .pipe(map((response) => response.content || []))
    );
  }
}
